import { render, staticRenderFns } from "./OtpCodeDialog.vue?vue&type=template&id=f3319384"
import script from "./OtpCodeDialog.vue?vue&type=script&lang=js"
export * from "./OtpCodeDialog.vue?vue&type=script&lang=js"
import style0 from "./OtpCodeDialog.vue?vue&type=style&index=0&id=f3319384&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports